// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteRanges_container__awXIX","headerContainer":"NoteRanges_headerContainer__APUQG"};